import { Injectable } from '@angular/core';

import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

export interface MemberModel {
  memberId: number;
  memberName: string;
}

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  baseUrl = window.location.origin;
  token = '';

  constructor(
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
  }

  getUserMembers() {
    let url = this.baseUrl + '/api/Member/GetUserMembers';
    this.baseAPIService.headerToken = this.token;

    return this.baseAPIService.getTU<MemberModel[]>(url);
  }
}
